import {
  
  IconButton,
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import { FC, useEffect, useMemo, useState } from "react";
import { useMutation } from "react-query";
import moment from "moment";
import { getEmrList } from "../services";
import { EmrListParams, EmrListType, initialSearchParams } from "./types";
import { base } from "../../constants";
import { useForm } from "react-hook-form";
import { CustomFormField } from "../../utilis/component/CustomFormElement";
import { FormOnChangeEventType } from "../types";
import CustomTableBody from "../../utilis/component/CustomTableBody";
import { useNavigate } from "react-router-dom";
import useAuthentication from "../../hooks/useAuthentication";
import debounce from "../../utilis/methods/networkHandling";
import usePopup from "../../hooks/usePopup";
import moduleRoutes from "../../routes/moduleRouteList";
import PageRouterList from "../../routes/routeList";
import { lightGreen } from "@mui/material/colors";
import DescriptionIcon from "@mui/icons-material/Description";
import ConsentFormV2 from "../components/ConsenForms/v2";
// import TaskAltIcon from "@mui/icons-material/TaskAlt";
const statusText: any = {
  waiting: {
    "not started": "success.main",
    started: "error.main",
    "re-opened": "error.main",
    stopped: "error.main",
    stop: "error.main",
  },
  consultation: {
    "not started": "warning.main",
    started: "success.main",
    "re-opened": "primary.main",
    stopped: "error.main",
    stop: "error.main",
  },
};
const EmrLandingPage: FC<{ path?: string }> = ({ path }) => {
  const navigateTo = useNavigate();
  const theme = useTheme();
  const { user } = useAuthentication();
  const { showSnackbar, CustomModal } = usePopup();
  const inEmr =
    path ==
    `${base}${moduleRoutes.mainRoute}/${moduleRoutes.patientCare}/${PageRouterList.emr}/`;
  const [searchParams, setSearchParams] = useState<EmrListParams>({
    ...initialSearchParams,
    userType: user?.groupId,
  });
  const [fetchTime, setFetchTime] = useState<moment.Moment | null>(null);
  const [openConsent, setOpenConsent] = useState(false);
  const [selectedPatient, setSelectedPatient] = useState<EmrListType | null>(
    null,
  );
  const { mutate, data, isLoading } = useMutation(getEmrList, {
    onSuccess: () => {
      setFetchTime(moment());
    },
    onError: (e: any) => {
      showSnackbar({
        message: e.response.data.responseMessage || "Something went wrong !",
        open: true,
        variant: "warning",
        duration: 3000,
      });
    },
  });
  const { control, setValue } = useForm();

  const handleSearch = (e: FormOnChangeEventType) => {
    const { name, value } = e.target;
    const filter = {
      ...searchParams.filter,
      [name]: value,
    };
    if (filter.searchText == "") {
      delete filter.searchText;
    }
    setSearchParams({
      ...searchParams,
      pageNumber: 0,
      filter,
    });
  };

  const onChange = debounce(handleSearch, 500);
  const handleNavigate = (patient: EmrListType) => {
    if (inEmr) {
      navigateTo(
        `${path}${patient.encounterID}/${patient.patientId}?emrno=${patient.emrNo}`,
      );
    }
  };
  const handleChangePage = (_: unknown, pageNumber: number) => {
    setSearchParams({
      ...searchParams,
      pageNumber,
    });
  };
  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const pageSize = parseInt(event.target.value, 10);
    setSearchParams({
      ...searchParams,
      pageSize,
    });
  };

  const list = useMemo(() => {
    if (data?.response.psearchResponses) {
      console.log(
        " data.response.psearchResponses..>>>",
        data.response.psearchResponses,
      );
      return data.response.psearchResponses;
    } else {
      return [];
    }
  }, [data?.response]);

  useEffect(() => {
    setValue("searchDate", initialSearchParams.filter.searchDate);
  }, []);

  useEffect(() => {
    mutate(searchParams);
  }, [searchParams]);

  //  const regionValue= user?.region;
  //    const idHeading =
  //  regionValue === "QATAR_REGION"
  //    ? "Qatar ID"
  //    : "Emirates Id";

  const [currentTime, setCurrentTime] = useState(moment());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(moment());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const parseDurationSeconds = (durationStr: string | null) => {
    if (!durationStr) return 0;
    const match = durationStr.match(/(\d+)d:(\d+)h:(\d+)m:(\d+)s/);
    if (!match) return 0;
    const [_, d, h, m, s] = match.map(Number);
    return d * 86400 + h * 3600 + m * 60 + s;
  };

  const formatSeconds = (totalSeconds: number) => {
    const d = Math.floor(totalSeconds / 86400);
    const h = Math.floor((totalSeconds % 86400) / 3600);
    const m = Math.floor((totalSeconds % 3600) / 60);
    const s = totalSeconds % 60;
    return `${d}d:${h.toString().padStart(2, "0")}h:${m
      .toString()
      .padStart(2, "0")}m:${s.toString().padStart(2, "0")}s`;
  };

  const getRunningDuration = (
    serverDurationStr: string | null,
    isRunning: boolean,
  ) => {
    if (!serverDurationStr) return "0d:00h:00m:00s";
    if (!isRunning || !fetchTime) return serverDurationStr;

    const serverSeconds = parseDurationSeconds(serverDurationStr);
    const elapsedSeconds = currentTime.diff(fetchTime, "seconds");
    return formatSeconds(serverSeconds + elapsedSeconds);
  };

  const idHeading = "Civil ID";
  const heading1 = [
    "SL NO",
    "PAYMENT",
    "EMR NO/REG NO",
    "DOCTOR",
    "PATIENT NAME",
    // `  ${idHeading}/PASSPORT ID/GCC ID` ,
    `${idHeading}`,
    "PAYMENT TYPE",
    "INSURANCE TYPE",
    "INSURANCE NAME",
    "CONSENT",
  ];
  const heading2 = [
    "SL NO",
    "PAYMENT",
    "EMR NO/REG NO",
    "DOCTOR",
    "PATIENT NAME",
    // `  ${idHeading}/PASSPORT ID/GCC ID` ,
    `${idHeading}`,
    "PAYMENT TYPE",
    "INSURANCE TYPE",
    "INSURANCE NAME",
    "WAITING TIME",
    "CONSULTATION TIME",
    "CONSENT",
  ];
  return (
    <div className="px-3 pt-4">
      <Paper className="flex flex-col gap-2">
        <TableContainer className="min-h-[80dvh] max-h-[80vh] relative ">
          <div className="px-4 py-2 border-b">
            <Typography variant="h6">Registered Patients</Typography>
          </div>
          <form className="py-4 px-2 grid grid-cols-4 gap-2">
            <CustomFormField
              control={control}
              element="datepicker"
              fieldProps={{ label: "Search date" }}
              name="searchDate"
              rules={{ required: false, onChange }}
            />
            <CustomFormField
              control={control}
              element="input"
              fieldProps={{ label: "Search name" }}
              name="searchText"
              rules={{ required: false, onChange }}
            />
          </form>
          <Table size="small" aria-label="simple table" className="border-b">
            <TableHead
              sx={{
                backgroundColor: theme.palette.background.paper,
              }}
              className="sticky w-full top-0 bg-inherit z-50"
            >
              <TableRow>
                {(user?.calendar == "NORMAL_CALENDAR"
                  ? heading1
                  : heading2
                ).map((title, index) =>
                  title == "PAYMENT" ? (
                    inEmr && (
                      <TableCell key={`${title}${index}`}>
                        <strong>{title}</strong>
                      </TableCell>
                    )
                  ) : (
                    <TableCell
                      key={`${title}${index}`}
                      align={
                        title === "WAITING TIME" || title === "CONSULTATION TIME"
                          ? "center"
                          : "left"
                      }
                    >
                      <strong>{title}</strong>
                    </TableCell>
                  ),
                )}
              </TableRow>
            </TableHead>
            <CustomTableBody
              alert={"No records"}
              dataLoading={isLoading}
              isData={list.length > 0}
              totalSpan={{
                col: inEmr
                  ? user?.calendar == "NORMAL_CALENDAR"
                    ? heading1.length
                    : heading2.length
                  : (user?.calendar == "NORMAL_CALENDAR"
                      ? heading1.length
                      : heading2.length) - 1,
                row: 10,
              }}
            >
              {list.map((row, index) => (
                <TableRow
                  onClick={() => {
                    handleNavigate(row);
                  }}
                  hover={inEmr ? row?.isCashed == 0 : true}
                  key={`emrlistId${index}`}
                  sx={
                    inEmr
                      ? rowStyle[`${row?.isCashed}` as keyof typeof rowStyle]
                      : rowStyle["0"]
                  }
                >
                  <TableCell align="center">
                    {searchParams.pageNumber * searchParams.pageSize +
                      index +
                      1}
                  </TableCell>

                  {inEmr && (
                    <TableCell>
                      {row?.isCashed == 1 && inEmr ? (
                        <span>
                          <Typography fontSize={12} color="success.main">
                            Cashed
                          </Typography>
                        </span>
                      ) : (
                        <span />
                      )}
                    </TableCell>
                  )}

                  <TableCell>{row.emrNo || "-"}</TableCell>
                  <TableCell>{row.doctorName || "-"}</TableCell>
                  <TableCell>{row.fullName || "-"}</TableCell>
                  <TableCell>
                    {row.emiratesId || row.passportNum || row.gccId || "-"}
                  </TableCell>
                  <TableCell>{row.paymentType || "-"}</TableCell>
                  <TableCell>
                    {row.paymentType == "Cash"
                      ? "-"
                      : row?.insuranceType || "-"}
                  </TableCell>
                  <TableCell>
                    {row.paymentType == "Cash"
                      ? "-"
                      : row?.insuranceName || "-"}
                  </TableCell>
                  {user?.calendar != "NORMAL_CALENDAR" && (
                    <>
                      <TableCell align="center">
                        {/* <div className="inline-flex items-center gap-2 bg-slate-50 border border-slate-200 rounded-full px-2.5 py-1 shadow-sm text-[10px] whitespace-nowrap"> */}
                         <div>
                          <div className="flex items-center gap-1">
                            {/* <span className="text-slate-400 font-bold">Waiting</span> */}
                            <Typography
                              component="span"
                              sx={{
                                fontSize: "10px",
                                fontWeight: 600,
                                color:
                                  statusText.waiting[
                                    row.consultationStatus?.toLowerCase() || ""
                                  ] || "success.main",
                              }}
                            >
                              {row.waitingTime
                                ? getRunningDuration(
                                    row.waitingTime,
                                    row.consultationStatus?.toLowerCase() ===
                                      "not started",
                                  )
                                : "-"}
                            </Typography>
                          </div>
                        </div>
                      </TableCell>

                      <TableCell align="center">
                        {/* <div className="inline-flex items-center gap-2 bg-slate-50 border border-slate-200 rounded-full px-2.5 py-1 shadow-sm text-[10px] whitespace-nowrap"> */}
                         <div>
                          <div className="flex items-center gap-1">
                            {/* <span className="text-slate-400 font-bold">Consultation</span> */}

                            <Typography
                              component="span"
                              sx={{
                                fontSize: "10px",
                                fontWeight: 600,
                                color:
                                  statusText.consultation[
                                    row.consultationStatus?.toLowerCase() || ""
                                  ] || "error.main",
                              }}
                            >
                              {row.consultationStatus?.toLowerCase() ==
                              "not started"
                                ? row.consultationStatus
                                : row.consultationTime
                                  ? getRunningDuration(
                                      row.consultationTime,
                                      row.consultationStatus?.toLowerCase() ===
                                        "started" ||
                                      row.consultationStatus?.toLowerCase() ===
                                        "re-opened",
                                    )
                                  : "-"}
                            </Typography>
                          </div>
                        </div>
                      </TableCell>
                    </>
                  )}
                  <TableCell align="center">
                    <Tooltip title="View Consent Forms" arrow placement="top">
                      <IconButton
                        size="small"
                        color="primary"
                        sx={{
                          bgcolor: "primary.50",
                          "&:hover": {
                            bgcolor: "primary.100",
                            transform: "scale(1.05)",
                          },
                          transition: "all 0.2s ease-in-out",
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          setSelectedPatient(row);
                          setOpenConsent(true);
                        }}
                      >
                        <DescriptionIcon fontSize="medium" />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))}
            </CustomTableBody>
          </Table>
        </TableContainer>
        <div className="border-t">
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={data?.response?.count || 0}
            rowsPerPage={searchParams.pageSize}
            page={searchParams.pageNumber}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
      </Paper>
      <CustomModal
        open={openConsent}
        setOpen={setOpenConsent}
        title="Consent Forms"
      >
        <ConsentFormV2
          encounterId={selectedPatient?.encounterID}
          emrNo={selectedPatient?.emrNo}
        />
      </CustomModal>
    </div>
  );
};

export default EmrLandingPage;

const rowStyle = {
  "0": {
    "&:last-child td, &:last-child th": { border: 0 },
    cursor: "pointer",
    bgcolor: "",
  },
  undefined: {
    "&:last-child td, &:last-child th": { border: 0 },
    cursor: "pointer",
    bgcolor: lightGreen[100],
  },
  "1": {
    "&:last-child td, &:last-child th": { border: 0 },
    // cursor: "default",
    cursor: "pointer",
    bgcolor: lightGreen[100],
  },
};
